import React, {  } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import { constantConfig } from 'web-common';

const { WEBSITE_PATHS } = constantConfig;


interface BannerPosterProps {
    align?: 'tl' | 'tr' | 'tc'; // 内容对齐方式 , 默认右对齐 
}


/**
 * banner上的通家和大字名称和主题
 */
const BannerPoster = (props: BannerPosterProps) => {

    const { align = 'tr' } = props;

    const { isMobile } = useSelector((state: any) => state.reducer);

    const history = useHistory();

    if (isMobile) {
        return (
            <div className={align}>
                <div className="f40 b lh40 ftr" onClick={() => history.replace(WEBSITE_PATHS.home)}>基准方中</div>
                <div className="f16 lh16">JZFZ  Architectural  Design  Co.,Ltd</div>
                <div className="f16 mt24 lh24" onClick={() => history.replace(WEBSITE_PATHS.service)}>大咨询  |  大设计  |  大管理</div>
                <div className="f14" onClick={() => history.replace(WEBSITE_PATHS.service)}>CONSULTING & PLANNING丨DESIGN丨MANAGEMENT</div>
            </div>
        );
    }

    return (
        <div className={align}>
            <div className="f66 crp b lh66 ftr" onClick={() => history.replace(WEBSITE_PATHS.home)}>基准方中</div>
            <div className="f24 lh24">JZFZ  Architectural  Design  Co.,Ltd</div>
            <div className="f24 mt24 crp lh32" onClick={() => history.replace(WEBSITE_PATHS.service)}>大咨询  |  大设计  |  大管理</div>
            <div className="f14 crp" onClick={() => history.replace(WEBSITE_PATHS.service)}>CONSULTING & PLANNING丨DESIGN丨MANAGEMENT</div>
        </div>
    );
};
export { BannerPoster };